<template>
	<div>

		<!-- <div>
			<table-filter :filters="filters" @onFilter="onFilterLocal" @onClear="clearFilters"></table-filter>
		</div> -->

		<FiltersTable titleButton="Obtener órdenes" searchPlaceholder="Buscar por 'Órden ML'" @onSearch="onSearch"/>

		<div v-if="showDetailsModal">
        <OrderDetails :orderDetail="orderDetails" @orderDetail="handleOrderDetails" />
    </div>
		
		<!-- Barra de acciones en lote: solo Flex, y solo con algo seleccionado -->
		<div v-if="mode === 'flex' && selected.length" class="flex items-center mb-4">
			<span class="mr-4">{{ selected.length }} orden(es) seleccionada(s)</span>
			<vs-button type="border" size="small" :disabled="printingLabels" @click="printSelectedLabels()">
				{{ printingLabels ? 'Generando...' : 'Imprimir etiquetas de Meli' }}
			</vs-button>
			<vs-button type="flat" size="small" class="ml-2" @click="selected = []">Limpiar</vs-button>
		</div>

		<VxTable 
			stripe
			:multiple="mode === 'flex'"
			:only-click-checkbox="mode === 'flex'"
			v-model="selected"
			:data="orders" 
			pagination 
			:max-items="30"
			:total="totalItems"
			:sst="true" 
			@change-page="handleChangePage">
			
			<template slot="thead">
				<vs-th style="min-width: 80px">Órden ML</vs-th>
				<vs-th style="min-width: 80px">NIC</vs-th>
				<vs-th style="min-width: 100px">Destinatario</vs-th>
				<!-- <vs-th style="min-width: 80px">Comprador</vs-th> -->
				<vs-th v-if="mode === 'flex'" style="min-width: 160px">Producto</vs-th>
				<vs-th style="min-width: 90px">Valor</vs-th>
				<vs-th v-if="mode === 'flex'" style="min-width: 140px">Destino</vs-th>
				<vs-th style="min-width: 110px">Fecha</vs-th>
				<!-- "Actualizada" y "Modo" salen del panel Flex: la solapa ya filtra por Flex, y esos dos lugares se usan para Producto y Destino. -->
				<vs-th v-if="mode !== 'flex'" style="min-width: 130px">Actualizada</vs-th>
				<vs-th v-if="mode !== 'flex'" style="min-width: 70px">Modo</vs-th>
				<!-- En Flex no va: la columna dice "Status CDS" pero muestra el estado de MERCADO LIBRE. Mal rotulada desde antes; se deja asi en ME1. -->
				<vs-th v-if="mode !== 'flex'" style="min-width: 90px">Status CDS</vs-th>
				<vs-th v-if="mode === 'flex'" style="min-width: 120px">Status Meli</vs-th>
				<vs-th style="min-width: 60px">Acción</vs-th>
			</template>

			<template slot-scope="{data}">
				<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
					<vs-td>
						{{ tr.id }}
						<br v-if="tr.pack_id" />
						<small v-if="tr.pack_id" class="order-pack-id">N° compra: {{ tr.pack_id }}</small>
					</vs-td>
					<vs-td>
						{{tr.cds_nic}}
					</vs-td>
					<vs-td>
						Cuenta: <em>{{tr.buyer.first_name}} {{tr.buyer.last_name}} ({{tr.buyer.nickname}}).</em> <br>
						<template v-if="tr.shipment_data && tr.shipment_data.receiver_address">
							Recibe:  <em>{{tr.shipment_data.receiver_address.receiver_name}} </em>
						</template>
					</vs-td>
					<!-- <vs-td>
						{{tr.buyer.billing_info.doc_number}}
					</vs-td> -->
					<vs-td v-if="mode === 'flex'">
						{{ productSummary(tr) }}
					</vs-td>
					<vs-td>
						$ {{tr.total_amount}}
					</vs-td>
					<vs-td v-if="mode === 'flex'">
						{{ destinationLabel(tr) }}
					</vs-td>
					<vs-td>
						{{ data[indextr].date_created | formatDate }}
					</vs-td>
					<vs-td v-if="mode !== 'flex'">
						{{ data[indextr].last_updated | formatDateFromNow }}
					</vs-td>
					<vs-td v-if="mode !== 'flex'">
						{{ orderModeLabel(tr) }}
					</vs-td>
					<vs-td v-if="mode !== 'flex'">
						{{tr.shipment_data.status | translateStatus}}
					</vs-td>
					<vs-td v-if="mode === 'flex'">
						{{ meliStatusLabel(tr) }}
					</vs-td>
					<!-- <vs-td>
						{{tr.buyer.billing_info.doc_number}}
					</vs-td> -->
					<vs-td>
						<!-- <vs-button type="border" size="small" color="primary" class="mr-2" 
							@click="openPopupDetalle(data[indextr])">
							<feather-icon icon="SearchIcon" svgClasses="h-2 w-2"/>
							Detalle
						</vs-button> -->
						<feather-icon class="order-action" @click="openDetails(tr)" title="Ver el detalle" icon="EyeIcon" svgClasses="h-5 w-5 mx-1 cursor-pointer" />
						<!-- Etiqueta de Meli: solo Flex -->
						<feather-icon class="order-action" v-if="mode === 'flex' && hasLabelAvailable(tr)" @click="printLabel(tr)" title="Imprimir la etiqueta" icon="PrinterIcon" svgClasses="h-5 w-5 mx-1 cursor-pointer" />
						<!-- Meli no tiene etiqueta para este estado. Ver §9.3. -->
						<feather-icon v-else-if="mode === 'flex'" :title="labelUnavailableTooltip(tr)" icon="PrinterIcon" svgClasses="h-5 w-5 mx-1 opacity-25 cursor-not-allowed" />
						<!-- Anular el envio en CDS. La orden NO se descarta: vuelve a "Por enviar" (§5.12). -->
						<feather-icon class="order-action order-action--danger" v-if="mode === 'flex'" @click="confirmCancelFlexShipment(tr)" title="Anular el envío" icon="XCircleIcon" svgClasses="h-5 w-5 mx-1 cursor-pointer text-danger" />
					</vs-td>
				</vs-tr>
			</template>

		</VxTable>

	</div>
</template>

<script>
// Extraer: 
// MOMENTJS and CONFIG
// AXIOS and CONFIG
// FILTERS 

import moment from 'moment'
import { translateStatus, orderModeLabel, meliStatusLabel, hasLabelAvailable, labelUnavailableTooltip, labelUnavailableShort, productSummary, destinationLabel } from "../../utils/orderLabels";
import { escapeHtml } from "../../utils/html";
import { cancelFlexShipment, downloadFlexLabel, downloadFlexLabels, saveBlob, readBlobError } from "../../services/meliFlex.service";
import { errorMessage } from "../../http";
import { showAlertMessage, showConfirmation, showError, showSuccess } from "../../services/alert.service";
moment.locale('es')

import axios from 'axios';
axios.defaults.withCredentials = true;

import OrderDetails from "../../components/modals/Orders/OrderDetails.vue";
import FiltersTable from "../../components/filters-table/FiltersTable.vue"



export default {
	components: {
		OrderDetails,
		FiltersTable
	},
	props: {
		// 'me1' | 'flex' — lo inyectan las rutas (ver router.js); default ME1.
		mode: { type: String, default: 'me1' }
	},
	data(){
		return {
			orders: [],
			ordersPreserved:[], // used when reseting local filtering
			totalItems: 0,
			selected: [], // Los items seleccionados con el checkbox 
			printingLabels: false,
			
			// Popup (detalle & proccesar)
			popupOrder: {}, // El item en que se ha clickeado Detalle o Procesar
			popupOrderShipmentInfo: null,

			// Popup - detalle
			popupDetalleActive: false,

			filtersSelected: [],

			orderDetails: {},
			showDetailsModal: false,

		}
	},

	filters : {
		formatDate(rawDate){
			return moment(rawDate).format("D-M-Y");
		},
		formatDateFromNow(rawDate){
			return moment(rawDate).fromNow();
		},
		translateStatus,
	},


	watch: {
		// Las rutas ME1 y Flex montan ESTE MISMO componente: Vue reutiliza la instancia y no vuelve a ejecutar mounted().
		mode() {
			this.page = 1;
			this.orders = [];
			this.ordersPreserved = [];
			this.totalItems = 0;
			this.selected = [];
			this.loadOrders(1);
		}
	},
	mounted() {
		this.loadOrders();		
	},

	methods: {
		orderModeLabel,
		meliStatusLabel,
		productSummary,
		destinationLabel,
		// Se exponen porque el template los usa: un import de modulo no es visible ahi.
		hasLabelAvailable,
		labelUnavailableTooltip,
		/** Etiqueta individual. El parametro es el id del ENVIO, no el de la orden. */
		async printLabel(tr) {
			const shipmentId = tr.shipment_data && tr.shipment_data.id;
			if (!shipmentId) {
				showError({ message: "La orden no tiene un envío asociado." });
				return;
			}

			// El boton ya viene deshabilitado en estos casos; esto cubre la llamada por codigo.
			if (!hasLabelAvailable(tr)) {
				showError({ message: labelUnavailableTooltip(tr) });
				return;
			}

			this.$vs.loading();
			try {
				const { data } = await downloadFlexLabel(shipmentId);
				saveBlob(data, `etiqueta-${shipmentId}.pdf`);
			} catch (e) {
				await this.showLabelError(e, "No se pudo obtener la etiqueta.");
			} finally {
				this.$vs.loading.close();
			}
		},

		/** Anula el envio. Se confirma porque genera un movimiento REAL en CDS, y el texto aclara que la orden vuelve a "Por enviar". */
		async confirmCancelFlexShipment(tr) {
			const { isConfirmed } = await showConfirmation({
				title: 'Anular el envío',
				text: `Se anulará en Cruz del Sur el envío de la orden #${tr.id}. La orden vuelve a "Por enviar" y se puede despachar de nuevo. ¿Continuar?`,
				textConfirmButton: 'Sí, anular el envío',
				popupClass: 'swal-popup-auto'
			});

			if (!isConfirmed) return;

			this.$vs.loading();

			try {
				const { data } = await cancelFlexShipment(tr.id);

				if (data && data.success === false) {
					showError({ message: data.message || 'No se pudo anular el envío.' });
				} else {
					showSuccess({ message: 'Envío anulado. La orden volvió a "Por enviar".' });
				}
			} catch (e) {
				// El interceptor ya avisa sesion vencida / timeout / sin conexion.
				const status = e.response && e.response.status;
				if (status && status !== 401 && status !== 419) {
					showError({ message: errorMessage(e, 'No se pudo anular el envío.') });
				}
			} finally {
				this.$vs.loading.close();
				// Se recarga tambien tras un error: si la anulacion salio bien la orden ya no esta en esta solapa.
				this.selected = [];
				// OJO: `page` no existe en data(). La pagina actual vive en filtersSelected.
				this.loadOrders(this.filtersSelected.page || 1);
			}
		},

		// Filtra las seleccionadas por etiqueta disponible ANTES de pedir el lote: ML descarta en silencio las que no la tienen (§9.3).
		async pickPrintableSelection() {
			const withShipment = this.selected.filter((o) => o && o.shipment_data && o.shipment_data.id);

			if (!withShipment.length) {
				showError({ message: "Ninguna de las órdenes seleccionadas tiene envío asociado." });
				return null;
			}

			const printable = withShipment.filter(hasLabelAvailable);
			const skipped = withShipment.filter((o) => !hasLabelAvailable(o));
			const detalle = skipped
				.map((o) => `• #${escapeHtml(String(o.id))} — ${escapeHtml(labelUnavailableShort(o))}`)
				.join("<br>");

			if (!printable.length) {
				await showAlertMessage({
					title: "Ninguna tiene etiqueta disponible",
					text: `No se puede imprimir ninguna de las ${skipped.length} órdenes seleccionadas:<br><br>${detalle}`,
					error: true,
					html: true,
					textCloseButton: "Entendido",
				});
				return null;
			}

			if (skipped.length) {
				const { isConfirmed } = await showConfirmation({
					title: `${printable.length} de ${withShipment.length} órdenes tienen etiqueta disponible`,
					text: `No se van a incluir:<br><br>${detalle}`,
					textConfirmButton: `Imprimir las ${printable.length}`,
					popupClass: "swal-popup-auto",
					html: true,
				});
				if (!isConfirmed) return null;
			}

			return printable;
		},

		/** Lote: el backend devuelve un unico PDF con todas las etiquetas. */
		async printSelectedLabels() {
			const printable = await this.pickPrintableSelection();
			if (!printable) return;

			const ids = printable.map((o) => o.shipment_data.id);

			this.printingLabels = true;
			this.$vs.loading();
			try {
				const { data } = await downloadFlexLabels(ids);
				saveBlob(data, 'etiquetas-flex.pdf');
				// Ahora el numero se puede afirmar: se pidieron solo las que tienen etiqueta.
				showSuccess({ message: `${ids.length} etiqueta(s) generada(s).` });
				this.selected = [];
			} catch (e) {
				// El tope de cantidad lo define el backend y viene en el mensaje del 422.
				await this.showLabelError(e, "No se pudieron obtener las etiquetas.");
			} finally {
				this.printingLabels = false;
				this.$vs.loading.close();
			}
		},

		/** Con responseType blob el error tambien llega como Blob: hay que leerlo. */
		async showLabelError(e, fallback) {
			const status = e.response && e.response.status;
			if (status === 401 || status === 419) return; // ya avisa el interceptor
			const message = await readBlobError(e);
			showError({ message: message || fallback });
		},

		loadOrders(page = 1) {
			this.$vs.loading();

			this.filtersSelected['page'] = page;
			this.filtersSelected['mode'] = this.mode;

			try {
				const filtersSelected = this.filtersSelected;
				const query = Object.keys(filtersSelected)
				.map(key => encodeURIComponent(key) + '=' + encodeURIComponent(filtersSelected[key]))
				.join('&');

				axios.get(process.env.VUE_APP_BACKEND_URL + 'api/orders-processed?' + query)
				.then(orders => {

					const body = orders.data.body || [];
					const paging = orders.data.paging || {};

					// Si `body` no viniera, antes la grilla se quedaba con las filas anteriores.
					this.orders = body;
					this.ordersPreserved = body;

					// `total` puede ser 0 en una busqueda sin resultados: con un `if` el paginador seguia en la consulta previa.
					this.totalItems = paging.total || 0;
				})
				.catch(e => {
					console.log(e);
				})
				.finally(() => {
					this.$vs.loading.close();
				});

			} catch (e) {
				console.log(e);
				this.$vs.loading.close(); 
			}
		},

		onSearch(value){
			this.filtersSelected = value;
			this.loadOrders(1);
		},

		handleChangePage (page) {
			this.selected = [];
			this.loadOrders(page)
		},

		// NEW METHODS FOR ACTIONS
		openDetails(tr) {
			this.orderDetails = tr;
			this.showDetailsModal = true;
		},
		handleOrderDetails() {
			this.showDetailsModal = false;
		},

	}
}
</script>